export default __webpack_public_path__ + "static/media/PROCESSMETHOD_PRINTING_POLYJET.128be854.png";